@if (isCreateMessageVisible()) {
  <app-create-in-hub-message-dialog [data]="displayedData()"
                                    (onBackClick)="isCreateMessageVisible.set(false)"
                                    (onSubmitClick)="isCreateMessageVisible.set(false)"></app-create-in-hub-message-dialog>
} @else {

  <div style="padding: 32px 40px 40px 40px;">
    <div class="title-large" style="margin-bottom: 32px">App Message</div>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

      <mat-tab style="height: 100%">
        <ng-template mat-tab-label><span class="title-small"
                                         style="padding-right: 12px;display: flex;align-items: center;gap: 8px"><img
          [ngSrc]="bus[0].flagUrl"
          width="24" height="24">{{ bus[0].buName }}</span>
          @if (currentMessage) {
            <span>(1)</span>
          }
        </ng-template>


        @if (currentMessage) {

          <div data-testid="settingsSection">
            <div class="title-medium" style="padding-top: 32px;padding-bottom: 12px">Settings</div>

            <div style="display: flex;gap: 32px">

              <div class="settings-list">
                <label class="title-small">Created</label>
                <div>{{ currentMessage.created| date:"dd MMM yyyy HH:mm" }}</div>

                <label class="title-small">Creator</label>
                <div>{{ currentMessage.createdBy }}</div>
              </div>
              <div class="settings-list">
                <label class="title-small">Visible</label>
                <div>{{ currentMessage.displayRoute }}</div>
                <label class="title-small">Dismissible</label>
                <div>{{ currentMessage.dismissible }}</div>
              </div>
            </div>
          </div>

          <div class="divider-h" style="margin: 24px 0"></div>

          <div class="title-medium" style="margin-top: 32px;margin-bottom: 16px">Message</div>

          <div class="messages-container">
            <div style="display: flex;gap:8px;flex: 1;flex-direction: column">
              <div class="title-small"> English</div>
              <div class="card" style="flex: 1">
                <div class="card-body" style="display: flex;flex-direction: column;gap: 16px;height: 100%">
                  <div class="title-small">{{ currentMessage.titles.en_GB }}</div>
                  <div class="body-large" style="flex: 1">{{ currentMessage.messages.en_GB }}</div>
                  <div class="label-large" [matTooltip]="currentMessage.externalUrl" style="color: var(--primary)">{{
                      currentMessage.linkText.en_GB
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div style="display: flex;gap:8px;flex: 1;flex-direction: column">
              <div class="title-small">Swedish</div>
              <div class="card">
                <div class="card-body" style="display: flex;flex-direction: column;gap: 16px;height: 100%">
                  <div class="title-small">{{ currentMessage.titles.sv_SE }}</div>
                  <div class="body-large" style="flex: 1">{{ currentMessage.messages.sv_SE }}</div>
                  <div class="label-large" [matTooltip]="currentMessage.externalUrl" style="color: var(--primary)">{{
                      currentMessage.linkText.sv_SE
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 40px;display: flex;gap:12px">
            <button data-testid="deleteButton" class="danger-button" (click)="removeMessage()">Delete
            </button>
            <button data-testid="updateButton" class="primary-button" (click)="openCreateDialog()">Update message
            </button>
          </div>

        } @else {
          <div class="current-message-info" style="text-align: center; display:grid;height: calc(100vh - 160px);justify-items: center;position: relative;
    align-content: center;">

            <svg width="44" height="67" viewBox="0 0 44 67" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 8.50794C0 3.80913 3.75228 0 8.38095 0H35.619C40.2477 0 44 3.80913 44 8.50794V58.4921C44 63.1909 40.2477 67 35.619 67H8.38095C3.75228 67 0 63.1909 0 58.4921V8.50794Z"
                fill="#0000C8"/>
              <path
                d="M21.9997 16.7486C20.1846 16.7486 18.9747 17.9769 18.9747 19.8195V35.175C18.9747 37.0176 20.1846 38.2458 21.9997 38.2458C23.8148 38.2458 25.0247 37.0176 25.0247 35.175V19.8195C25.0247 17.9774 23.8148 16.7486 21.9997 16.7486Z"
                fill="white"/>
              <path
                d="M25.0247 44.3863C25.0247 42.6902 23.6705 41.3155 21.9997 41.3155C20.3289 41.3155 18.9747 42.6902 18.9747 44.3863C18.9747 46.0824 20.3289 47.4577 21.9997 47.4577C23.6705 47.4577 25.0247 46.0824 25.0247 44.3863Z"
                fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.9747 19.8195C18.9747 17.9769 20.1846 16.7486 21.9997 16.7486C23.8148 16.7486 25.0247 17.9774 25.0247 19.8195V35.175C25.0247 37.0176 23.8148 38.2458 21.9997 38.2458C20.1846 38.2458 18.9747 37.0176 18.9747 35.175V19.8195ZM21.9997 41.3155C23.6705 41.3155 25.0247 42.6902 25.0247 44.3863C25.0247 46.0824 23.6705 47.4577 21.9997 47.4577C20.3289 47.4577 18.9747 46.0824 18.9747 44.3863C18.9747 42.6902 20.3289 41.3155 21.9997 41.3155Z"
                    fill="white"/>
            </svg>
            <div data-testid="noActiveMessage" class="title-large" style="margin-top: 24px">There are no active app
              messages
            </div>
          </div>
          <div
            style="position: fixed;text-align:center;bottom: 0;left: 0;right: 0; background: white;padding: 16px;box-shadow: 0 -4px 22px 0 rgba(2,8,24,0.25); z-index: 999;margin-left: 359px; max-height: 48px;">
            <button class="primary-button" (click)="openCreateDialog()">Create app
              message
            </button>
          </div>
        }
      </mat-tab>
    </mat-tab-group>
  </div>
}
